import { WrapperGS } from '../core/WrapperGS';

export class ToggleGS extends WrapperGS {
    static TagClassName = 'gs-toggle';

    constructor(el: HTMLElement | string) {
        super(el);
        if (!this.hasClass(ToggleGS.TagClassName))
            throw new Error('Trying create ToggleGS from HTMLElement without specific class in classList');
        this.el.addEventListener('click', () => this.activeFlip());
    }
}

WrapperGS.ExtendComponentsByTagClass(ToggleGS);
